import HOC from "../../components/HOC";
import PSEFSettingComponents from "../../components/screen/settings/PSEFSetting";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";

const PSEFSetting = () => {
  return (
    <div className="">
      <PageTemplate
        header="PSEF Settings"
        mainComponent={<PSEFSettingComponents />}
        checkOwner={true}
      />
    </div>
  );
};

export default HOC(PSEFSetting);
